import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../authentication/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/signin" replace state={{ from: location }} />;
  }

  return children;
}


